<template>
  <strong
    class="block font-medium max-lg:text-[11px] text-[13px] tracking-widest leading-5 uppercase mb-6"
  >
    <slot />
  </strong>
</template>
